<template>
  <div class="trail-comment">
    <h6 class="mb-0">
      {{ comment.name }}
      <small>{{ time(comment) }}</small>

      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none text-light"
        right
        no-caret
        v-if="$user.user.id == comment.user_id"
      >
        <template v-slot:button-content>
          <i class="fas fa-ellipsis-h" />
        </template>

        <b-dropdown-item @click="$emit('edit', comment)">
          Editar
        </b-dropdown-item>
        <b-dropdown-item @click="$emit('remove', comment)">
          Remover
        </b-dropdown-item>
      </b-dropdown>
    </h6>
    <div class="mb-2">{{ comment.text }}</div>
    <button
      class="btn btn-sm p-0 text-secondary"
      @click="$emit('reply', comment)"
    >
      <i class="fas fa-reply"></i> Responder
    </button>

    <comment
      v-for="child in comment.children"
      :key="child.id"
      :comment="child"
      @edit="$emit('edit', child)"
      @remove="$emit('remove', child)"
      @reply="$emit('reply', child)"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import "dayjs/locale/pt";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("pt");

export default {
  name: "comment",
  props: {
    comment: Object
  },
  methods: {
    time(comment) {
      return dayjs().to(dayjs(comment.created_at).add(3, "hour"));
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-comment {
  margin: 16px 0px;
  border-radius: 8px;
  padding: 16px 16px 10px;
  background: rgba(255, 255, 255, 0.03);
  font-size: 14px;

  h6 {
    position: relative;

    small {
      margin-left: 4px;
    }
  }

  .btn-sm {
    font-size: 12px;
  }

  ::v-deep .dropdown {
    position: absolute;
    right: 0;
    top: 0;

    .dropdown-toggle::after {
      display: none;
    }
  }
}
</style>
